import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { Creators } from "../../../login/reducer";
import Toolbar from "./Toolbar";

const enhance = compose(
  withRouter,
  connect(
    state => ({
      rangeLocation: state.login.location,
      locations: state.data.locations
    }),
    dispatch => ({
      onLogout: () => {
        dispatch(Creators.logout());
      }
    })
  )
);

export default enhance(Toolbar);



// WEBPACK FOOTER //
// ./src/admin/components/Toolbar/index.js